import SplitScreenContent from "../../components/SplitScreenContent";

export const motorsport = {
  title: "Motorsport & Trackday-Vorbereitung für Porsche 911",
  titleImageUrl: "porsche-engine.jpg",
  meta: {
    title:
      "Porsche Motorsport & Trackday Vorbereitung – Fahrwerk, Leistung, Sicherheit | WTM Sportwagen",
    description:
      "WTM Sportwagen bereitet Ihren Porsche 911, 964, 993, 996, 997 oder Cayman perfekt für den Trackday vor: Fahrwerksabstimmung, Leistungssteigerung, Bremsen & Sicherheit, Betreuung an der Rennstrecke.",
  },
  content: [
    {
      type: "hero_image",
      backgroundImage:
        "https://res.cloudinary.com/donwh3eei/image/upload/v1756323701/gallery/frank_kayser/M10_6908_jiwup7.jpg",
      headline: "Porsche Motorsport & Trackday-Setup",
      description:
        "Ob Trackday, Club-Sport oder Nordschleife – wir machen Ihren Porsche fit für den Grenzbereich. Von der Fahrwerksabstimmung bis zu Motor-Setups, Bremsen und Sicherheit bieten wir maßgeschneiderte Motorsportlösungen.",
      hasVignette: true,
      overlayOpacity: 0.01,
    },
    {
      type: "text_section_hero",
      // headline: "Porsche Motorsport & Trackday-Setup",
      lead: "Ob Trackday, Club-Sport oder Nordschleife – wir machen Ihren Porsche fit für den Grenzbereich. Von der Fahrwerksabstimmung bis zu Motor-Setups, Bremsen und Sicherheit bieten wir maßgeschneiderte Motorsportlösungen.",
      highlight:
        "Performance ist kein Zufall – sondern das Ergebnis von Erfahrung und Präzision.",
      spacing: "comfortable",
      size: "md",
      variant: "primary",
      margin: false,
    },
    {
      type: "split_screen_layout",
      leftImage: "gallery/cars/watercooled_marketing/1_sb3ocu",
      headline: "Motorsport bei WTM",
      rightContent: (
        <SplitScreenContent
          headline="Ihr Porsche für die Rennstrecke"
          intro="Ob Trackday, Club-Sport oder Nordschleife – wir machen Ihren Porsche fit für den Grenzbereich. Jahrzehntelange Erfahrung mit allen Porsche-Generationen, von luftgekühlten Klassikern bis zu modernen GT-Modellen."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Fahrwerk & Performance",
              level: 3,
            },
            {
              type: "paragraph",
              text: "KW Competition, Bilstein Clubsport, Corner Weighting – wir stimmen Ihr Fahrwerk präzise auf Ihren Fahrstil und die Strecke ab. Dazu Leistungssteigerungen mit ECU-Optimierung und Ölkühler-Upgrades.",
            },
            {
              type: "heading",
              text: "Sicherheit geht vor",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Überrollbügel, Rennsitze, 6-Punkt-Gurte, Motorsport-Bremsflüssigkeit – alle Sicherheitskomponenten werden fachgerecht eingebaut und bei Bedarf TÜV-eingetragen.",
            },
            {
              type: "heading",
              text: "Alltagstauglich bleiben",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir achten auf die richtige Balance zwischen Rennstrecken-Performance und Alltagstauglichkeit. Ihr Tracktool soll Spaß machen, nicht nur schnell sein. <a href='/porsche-gutachten' class='hyperlink'>Falls Sie Hilfe bei TÜV-Eintraung oder Gutachten benötigen, finden Sie hier weitere Informationen</a>.",
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Tracktool-Projekt starten",
                paragraph:
                  "Sprechen Sie mit uns über Ihr Motorsport-Projekt. Wir beraten Sie zu Setup, Sicherheit und Performance.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorsport - Porsche Trackday Vorbereitung",
      navbarHeight: 0,
    },

    {
      type: "split_screen_layout",
      leftImage: "gallery/marketing_stock/iStock-171310367_kbikev",
      headline: "Von Alltag bis Rennstrecke",
      rightContent: (
        <SplitScreenContent
          headline="Maßgeschneiderte Motorsport-Lösungen"
          intro="Alle Umbauten werden sorgfältig geplant, dokumentiert und auf Wunsch mit TÜV-Gutachten durchgeführt. Ob Trackdays, Clubrennen oder Gleichmäßigkeitsprüfungen – wir haben die Lösung."
          padding="py-24 px-4 lg:px-24"
          blocks={[
            {
              type: "heading",
              text: "Für alle Porsche-Generationen",
              level: 3,
            },
            {
              type: "paragraph",
              text: "911, 964, 993, 996, 997, Cayman – wir kennen die Stärken und Schwächen jeder Generation und stimmen die Setups entsprechend ab.",
            },
            {
              type: "heading",
              text: "Bewährte Komponenten",
              level: 3,
            },
            {
              type: "paragraph",
              text: "Wir setzen auf bewährte Komponenten und präzise Abstimmung. Performance und Zuverlässigkeit müssen Hand in Hand gehen.",
            },
            {
              type: "component",
              component: "IconBulletListV2",
              props: {
                headline: "Warum WTM Sportwagen?",
                items: [
                  "Individuelle Setups für Trackdays, Clubsport oder ambitioniertes Fahren",
                  "Hol- und Bringservice deutschlandweit für Ihr Fahrzeug",
                  "Transparente Kommunikation & Projektbegleitung",
                  "TÜV-konforme Lösungen und Dokumentation",
                ],
                highlightedIndices: [0, 1],
                icon: "check",
              },
            },
            {
              type: "component",
              component: "CallToActionWithModalV2",
              props: {
                headline: "Jetzt Motorsport-Beratung vereinbaren",
                paragraph:
                  "Wir beraten Sie persönlich zu Ihrem Motorsport-Projekt.",
                darkMode: false,
                margin: false,
              },
            },
          ]}
        />
      ),
      imageAlt: "WTM Sportwagen Motorsport - Porsche Performance Setup",
      navbarHeight: 0,
    },
    {
      type: "relevant-posts",
      postSlugs: ["964-993-leistungssteigerung"],
      headline: "Werkstatt Journal: Motorsport & Trackday",
      introText:
        "Entdecken Sie weitere Artikel zu Porsche Motorsport, Tracktools und Performance-Optimierungen in unserem Werkstatt Journal.",
      darkMode: false,
    },
  ],
};
